module.exports = __webpack_public_path__ + "img/Info.7ff3a887.svg";